import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Star, Crown, Shield } from "lucide-react";

const BADGE_CONFIG = {
  admin:       { icon: Shield, color: "text-yellow-400", label: "Administrador" },
  road_master: { icon: Crown,  color: "text-amber-400",  label: "Road Master" },
  road_pro:    { icon: Star,   color: "text-purple-400", label: "Road Pro" },
};

export function PlanBadgeIcon({ badge, size = "h-3.5 w-3.5" }) {
  const cfg = badge ? BADGE_CONFIG[badge] : null;
  if (!cfg) return null;
  const Icon = cfg.icon;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex" data-testid={`plan-badge-icon-${badge}`}>
            <Icon className={`${size} ${cfg.color}`} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          {cfg.label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
